import React from 'react';
import { HomeIcon } from "src/components/ui-icons/menu";

function NoAccess(){
  return (
    <div className={`max-h-[100vh] flex flex-col h-[100vh] overflow-y-hidden`}>
      <div className="px-7.5 py-4 border-b flex items-center gap-2">
        <HomeIcon />
        <p className="mr-auto">Главная</p>
      </div>
      <div className='text-center flex flex-col min-h-[80%] items-center justify-center'>
        <div className='mb-[20px] font-medium text-[18px] text-[#111928]'>У вас нет доступа</div>
        <div className='text-[14px] font-medium text-[#637381]'>Пожалуйста, обратитесь к администратору</div>
      </div>
    </div>
  )
}

export default NoAccess;